<template>
<!-- Container para toda la página: ******************************************************* -->

    <v-container fill-height fluid class="sign-in">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm8 md6 lg5 elevation-6>
                <!-- oncontextmenu="return false" Previene hacer "Inspect" en el browser: -->
                <v-card class="elevation-12 pa-4" color="grey lighten-5" oncontextmenu="return false">
                    <v-card-text>
                        <v-container grid-list-sm>
                            <v-layout row justify-space-between>
                                <v-flex shrink>
                                    <img height="65" :src="uiaLogoPositivo" />
                                </v-flex>
                                <v-flex shrink>
                                    <img height="65" :src="logoAOCS" />
                                </v-flex>
                            </v-layout>
                            <v-divider class="red darken-4"></v-divider>
                            <v-layout row>
                                <v-flex xs12>
                                    <div class="uia-red headline font-weight-medium">
                                        <p></p>Inicio de Sesión
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout row justify-space-around>
                                <v-flex xs12>
                                    <v-form ref="form" v-model="valid" @submit.prevent>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="text-left body-2 red--text text--darken-1 font-weight-medium">
                                                    Usa tu número de cuenta sin dígito verificador y tu contraseña habitual:
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-space-around>
                                                <v-flex xs11 sm10 md9>
                                                    <v-text-field
                                                        color="red darken-1"
                                                        prepend-icon="mdi-account"
                                                        name="user"
                                                        label="Número de cuenta"
                                                        type="text"
                                                        v-model="user"
                                                        :rules="userRules"
                                                        required
                                                        align-self-center
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-around>
                                                <v-flex xs11 sm10 md9>
                                                    <v-text-field
                                                        color="red darken-1"
                                                        prepend-icon="mdi-lock"
                                                        name="password"
                                                        label="Contraseña"
                                                        id="password"
                                                        required
                                                        v-model="password"
                                                        :append-icon="e1 ? 'mdi-eye-off' : 'mdi-eye'"
                                                        @click:append="() => (e1 = !e1)"
                                                        :type="e1 ? 'password' : 'text'"
                                                        :rules="passwordRules"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-around>
                                                <v-flex shrink>
                                                    <!-- <re-captcha></re-captcha> -->
                                                    <my-captcha></my-captcha>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row>
                                                <v-spacer></v-spacer>
                                                <v-spacer></v-spacer>

                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    type="submit"
                                                    @submit.prevent="checkLogin"
                                                    @click="onSubmit"
                                                    :disabled="!captchaOK"
                                                    :class="{
                                                                'red darken-1 white--text': valid,
                                                                disabled: !valid
                                                            }"
                                                >OK</v-btn>
                                            </v-layout>
                                        </v-container>
                                    </v-form>
                                </v-flex>
                            </v-layout>

                            <!-- Modal para informar que el usuario o el password son incorrectos: *********************************** -->
                            <v-layout row justify-center>
                                <v-dialog v-model="failedLogin" persistent :width="errorModalWidth">
                                    <v-card class="grey lighten-4">
                                        <v-toolbar dense color="red darken-1" dark flat>
                                            <v-toolbar-title
                                                class="my-list-title"
                                            >Información no válida</v-toolbar-title>
                                            <v-spacer></v-spacer>
                                            <v-icon>mdi-alert-circle</v-icon>
                                        </v-toolbar>
                                        <v-card-title>
                                            <v-container>
                                                <v-layout row>
                                                    <v-flex xs12 class="d-flex justify-center">
                                                        <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex
                                                        xs12
                                                        class="d-flex justify-center text-center"
                                                    >Usuario o contraseña no válidos.</v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-title>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="green darken-4"
                                                class="text-none"
                                                text
                                                @click="failedLogin = false"
                                            >OK</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-layout>
                            <!-- Termina modal para informar que el usuario o el password son incorrectos *********************************** -->

                            <!-- Modal para informar que el usuario no está activo: *********************************** -->
                            <v-layout row justify-center>
                                <v-dialog
                                    v-model="inactiveUser"
                                    persistent
                                    :width="errorModalWidth"
                                >
                                    <v-card class="grey lighten-4">
                                        <v-toolbar dense color="teal" dark flat>
                                            <v-toolbar-title class="my-list-title">Usuario inactivo</v-toolbar-title>
                                            <v-spacer></v-spacer>
                                            <v-icon>error_outline</v-icon>
                                        </v-toolbar>
                                        <v-card-title>
                                            <v-container>
                                                <v-layout row>
                                                    <v-flex xs12 class="d-flex justify-center">
                                                        <v-icon
                                                            large
                                                            color="orange darken-2"
                                                        >mdi-alert</v-icon>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex
                                                        xs12
                                                        class="d-flex justify-center text-center"
                                                    >El usuario no está activo en el sistema.</v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-title>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="teal darken-3"
                                                class="text-none"
                                                text
                                                @click="inactiveUser = false"
                                            >OK</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-layout>

                            <!-- Termina modal para informar que el usuario no está activo *********************************** -->
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-footer absolute color="black" dark>
            <v-spacer></v-spacer>
            <div>&copy; Grupo Tecnológico Santa Fe, S.A. de C.V. {{ new Date().getFullYear() }} &nbsp; v. {{ version }}</div>
        </v-footer>
        
    </v-container>
</template>


<script>
import { mapGetters } from 'vuex';
//import ReCaptcha from '@/components/ReCaptcha.vue';
import MyCaptcha from '@/components/MyCaptcha.vue';
export default {
    data() {
        return {
            valid: false,
            e1: true,
            password: '',
            passwordRules: [
                v => !!v || 'Introduzca la contraseña',
                v => /^[\S]*$/.test(v) || 'Teclea tu contraseña',
                v => v && v.length <= 15 || 'La contraseña no puede tener más de 15 caracteres'
            ],
            email: '',
            emailRules: [
                v => !!v || 'Introduzca su correo electrónico',
                v =>/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Introduzca un correo válido',
                v => v && v.length <= 30 || 'El correo no puede tener más de 30 caracteres'
            ],
            user: '',
            userRules: [
                v => !!v || 'Teclea tu número de cuenta',
                v =>/^\w+([\.-]?\w+)*@{0,1}\w+([\.-]?\w+)*((\.\w{2,3}){0,})+$/.test(v) || 'Teclea un número de cuenta válido, sin dígito verificador',
                v => v && v.length <= 30 || 'El número de cuenta no puede tener más de 30 caracteres'
            ],
        };
    },
    created() {
        //console.log("Signin created...");
        this.captchaOK = false;
        this.submittingRecaptcha = false;
    },
    components: {
        //ReCaptcha,
        MyCaptcha,
    },
    methods: {
        onSubmit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('login', {
                    //email: this.email,
                    user: this.user,
                    password: this.password
                });
            }
        },
        clear() {
            this.$refs.form.reset();
        }
    },
    computed: {
        ...mapGetters(['version', 'uiaLogoPositivo','logoAOCS']),
        failedLogin: {
            get() {
                    return this.$store.getters.failedLogin;
            },
            set(failedLogin) {
                this.$store.dispatch('updateFailedLogin', failedLogin);
            },
        },
        inactiveUser: {
            get() {
                return this.$store.getters.inactiveUser;
            },
            set(inactiveUser) {
                this.$store.dispatch('updateInactiveUser', inactiveUser);
            }
        },
        waitCursor() {
            return this.$store.getters.waitCursor;
        },
         errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },
        captchaOK: {
            get() {
                return this.$store.getters.captchaOK;
            },
            set(captchaOK) {
                this.$store.dispatch('updateCaptchaOK', captchaOK);
            },
        },

        submittingRecaptcha: {
            get() {
                return this.$store.getters.submittingRecaptcha;
            },
            set(submittingRecaptcha) {
                this.$store.dispatch('updateSubmittingRecaptcha', submittingRecaptcha);
            },
        },
    },
    
};
</script>

<style scoped>
.sign-in {
    /* background: url('../assets/patiogallo1.jpg'); */
    background-color: #ef5350;
    background-size: cover;
    width: 100%;
    height: 100%;
}

.uia-red {
    color:#ef4044!important;
}


/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>
